import * as Preact from "preact"

import Unit from "@fae/source/models/Unit.js"

import elements from "@fae/source/data/elements.js"

import {Power, Powerboost, ShortPower} from "./Description.jsx"
import Icon from "./Icon.jsx"
import "./ItemBreakdown.less"

const rarities = {
    "1": {"name": "Common"},
    "2": {"name": "Uncommon"},
    "X": {"name": "Legendary"},
    "?": {"name": "Unidentified"},
}

const weaponTypes = {
    "axe": {"name": "Axe"},
    "bow": {"name": "Bow"},
    "spear": {"name": "Spear"},
    "sword": {"name": "Sword"},
    "staff": {"name": "Staff"},
    "song": {"name": "Song"},
    "shield": {"name": "Sheild"},
    "tome": {"name": "Tome"},
    "fist": {"name": "Fist"},
    "item": {"name": "Item"},
}

export default function ItemBreakdown({item, unit, stage}) {
    if(item == undefined) return

    const element = elements[item.element]
    const rarity = rarities[item.draftTier || 2] || rarities["?"]
    const weaponType = weaponTypes[item.weaponType] || rarities["item"]
    const power = Unit.power({"stage": stage, "unit": unit, "item": item})
    const powerboosts = Unit.powerboosts({"stage": stage, "unit": unit, "item": item})
    const isBoosted = powerboosts.length >= 2

    return (
        <div class="ItemBreakdown">
            <div class="Contents" isSmall={this.props.isSmall || item.isSmall}>
                <Icon iconKey={this.props.item.iconKey} icon={this.props.item.icon}/>
                <div class="Summary">
                    <div class="Title">{item.title} <ShortPower>{power}</ShortPower></div>
                    <div class="CoolDescription">
                        {item.description instanceof Function ? item.description({item, unit, stage}) : item.description}
                    </div>
                    {<div class="PowerCalculation" isRendered={isBoosted}>
                        {powerboosts.map((powerboost, index) => {
                            if(powerboost.source == "passive powerboost") {
                                return (
                                    <div class="Powerboost">
                                        <Powerboost>{powerboost.power}</Powerboost> {powerboost.passive.title} Bonus
                                    </div>
                                )
                            }
                            // return (
                            //     <div class="Powerboost">
                            //         <Powerboost>{powerboost.power}</Powerboost> {powerboost.type} {powerboost.source}
                            //     </div>
                            // )
                        })}
                    </div>}
                </div>
                <div class="KeywordDefinition" hasKeyword={!!item.keyword}>
                    <div class="Text">{item.keyword?.name ? (<b>{item.keyword?.name + ": "}</b>) : ""}{item.keyword?.description()}</div>
                </div>
                <div class="Flavor" isRendered={!!item.flavor}>
                    <div class="Text">{item.flavor}</div>
                </div>
                <div class="Elements" isRendered={!!item.element && item.element != "null"} element={item.element}>
                    <span>{rarity?.name}</span> <span class="Keyword" element={element.key}>{element.name}</span> <span>{weaponType?.name}</span>
                </div>
            </div>
        </div>
    )
    // <div class="Elements" isRendered={!!item.element && item.element != "null"} element={item.element}>
    //     <div class="Element"><span class="Keyword" element={element.key}>{element.name}</span> Type</div>
    //     <div class="Effectiveness">
    //         Strong against <span class="Keyword" element={element.strengths[0]}>{elements[element.strengths[0]].name}</span> (2x damage)
    //     </div>
    //     <div class="Ineffectiveness">
    //         Weak against <span class="Keyword" element={element.weaknesses[0]}>{elements[element.weaknesses[0]].name}</span> (½x damage)
    //     </div>
    // </div>
}
